module.exports = __webpack_public_path__ + "img/Leibniz_rose.e5fb66b0.jpg";